import styled, { createGlobalStyle } from 'styled-components';

import { GlobalToken } from 'antd';

export const MobileDrawerMenuContainer = styled.div<{ theme: { token: GlobalToken } }>`
  width: 100%;
  background-color: ${({ theme: { token } }) => token.colorBgBase};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${({ theme: { token } }) => token.paddingSM}px;
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 2;

  .hamburger-menu-icon {
    position: absolute;
    top: 12px;
    right: 12px;
  }

  .title-container {
    display: flex;
    align-items: center;

    .title {
      color: ${({ theme: { token } }) => token.colorText};
      font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
      font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
      margin-left: ${({ theme: { token } }) => token.marginSM}px;
      text-transform: capitalize;
      padding-top: ${({ theme: { token } }) => token.paddingXXS}px;
    }
  }
`;

export const DrawerGlobalStyles = createGlobalStyle<{ theme: { token: GlobalToken } }>`
.ant-drawer  {
  .mobile-drawer-menu {
      .ant-drawer-body {
        background-color: ${({ theme: { token } }) => token.colorBgBase};
        padding: 0;
        height: 100%;
        display: flex;
      flex-direction: column;

      .header {
        display: flex;
        justify-content: flex-end;
        padding: ${({ theme: { token } }) => token.paddingSM}px;
      }

      .nav-items-container {
        display: flex;
        flex-direction: column;
        padding: ${({ theme: { token } }) => token.paddingLG}px 0;
        flex-grow: 1;

        .menu-item {
          a {
            display: flex;
            align-items: center;
            padding: ${({ theme: { token } }) => token.padding}px ${({ theme: { token } }) => token.paddingXL}px;
            text-decoration: none;
            color: ${({ theme: { token } }) => token.colorText};
            
            .icon {
              width: 24px;
              height: 24px;
              margin-right: ${({ theme: { token } }) => token.marginSM}px;
            }

            .label {
              font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
              font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
              text-transform: capitalize;
            }
          }

          a.active {
            h3 {
              color: ${({ theme: { token } }) => token.colorPrimary};
            }

            path {
              stroke: ${({ theme: { token } }) => token.colorPrimary};
            }

            .icon-ai path {
              fill: ${({ theme: { token } }) => token.colorPrimary};
            }
          }

          &:last-child {
            margin-top: auto;
            border-top: 1px solid ${({ theme: { token } }) => token.colorBorderSecondary};
          }
        }
      }
      }
    }
  }
`;
